export enum EUpgradeView {
  STORE = 0,
  PAYMENT = 1,
  PAYMENT_SUCCESS = 2
}
